import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { TASKASSIGNMENT_DETAIL_BY_ID, TASK_GET_FILE } from "./apiRoutes";

export interface TaskAssignment {
  _id: string;
  taskId: string;
  taskName: string;
  priority: string;
  startDate: string;
  endDate: string;
  taskStatus: string;
  taskAttachment?: string; // attachment ID
  taskAttachmentName?: string; // 👈 added for file_name
  isActive: boolean;
  latestNote?: string;
  school: string;
  role: string;
  assignTo: string;
  createdBy: string;
  lastUpdatedBy: string;
  createdAt: string;
  updatedAt: string;
  schoolData?: any[];
  assignToData?: any[];
  taskNotes?: any[];
  attachmentFile?: FileData | null; // file info
}

export interface FileData {
  fileName: string;
  fileUrl: string;
  mimeType: string;
  size?: number;
}

export interface TaskAssignmentResponse {
  status: number;
  error: boolean;
  count: number;
  issues: any[];
  data: TaskAssignment;
  message: string;
}

const fetchTaskAssignmentById = async (id: string) => {
  const response = await axiosAuth.get<TaskAssignmentResponse>(
    `${TASKASSIGNMENT_DETAIL_BY_ID}${id}`
  );

  const taskData = response.data.data;

  // ✅ If attachment exists, fetch file details
  if (taskData?.taskAttachment) {
    try {
      const fileRes = await axiosAuth.get(`${TASK_GET_FILE}${taskData.taskAttachment}`);
      const fileInfo = fileRes.data?.data || null;

      // ✅ Store both file info & name
      taskData.attachmentFile = fileInfo;
      taskData.taskAttachmentName = fileInfo?.fileName || taskData.taskAttachmentName || null;
    } catch (err) {
      console.error("Error fetching file:", err);
      taskData.attachmentFile = null;
    }
  }

  return { ...response.data, data: taskData };
};

export const useGetTaskAssignmentByIdQuery = (
  id: string,
  options?: Omit<
    UseQueryOptions<TaskAssignmentResponse, Error, TaskAssignmentResponse>,
    "queryKey" | "queryFn"
  >
) => {
  return useQuery({
    queryKey: ["taskAssignment", id],
    queryFn: () => fetchTaskAssignmentById(id),
    enabled: !!id,
    ...options,
  });
};
